import { render, staticRenderFns } from "./DeleteDisbursementDialog.vue?vue&type=template&id=52c3fbca&"
import script from "./DeleteDisbursementDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteDisbursementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QForm,QCardSection,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QForm,QCardSection,QSeparator,QCardActions})
